export default function themePalette(theme) {
  const t = theme.t;
  const g = t.greyScale;

  return {
    mode: t.mode,
    common: {
      black: '#0b0b0f',
      white: '#ffffff'
    },

    primary: {
      light: t.primarySoft,
      main: t.primary,
      dark: t.primaryText,
      200: t.primary200,
      800: t.primary800,
      contrastText: t.onPrimary
    },
    secondary: {
      light: t.primarySoft,
      main: t.primary,
      dark: t.primaryText,
      200: t.primary200,
      800: t.primary800,
      contrastText: t.onPrimary
    },
    secondaryDark: {
      light: t.primarySoft,
      dark: t.primary
    },
    primaryDark: {
      dark: t.primaryText
    },

    error: {
      light: t.dangerSoft,
      main: t.danger,
      dark: t.dangerText,
      contrastText: t.onDanger
    },
    warning: {
      light: t.warnSoft,
      main: t.warn,
      dark: t.warnText,
      contrastText: t.onWarn
    },
    orange: {
      light: t.warnSoft,
      main: t.warn,
      dark: t.warnText,
      contrastText: t.onWarn
    },
    info: {
      light: t.infoSoft,
      main: t.info,
      dark: t.infoText,
      contrastText: t.onInfo
    },
    blue: {
      light: t.infoSoft,
      main: t.info,
      dark: t.infoText
    },
    success: {
      light: t.successSoft,
      200: t.successBorder,
      main: t.success,
      dark: t.successText,
      contrastText: t.onSuccess
    },

    grey: {
      50: g[50],
      100: g[100],
      200: g[200],
      300: g[300],
      400: g[400],
      500: t.text3,
      600: t.text,
      700: t.text2,
      800: g[800],
      900: t.text,
      background: t.canvas
    },
    greyNumb: { ...g },
    dark: {
      light: t.text2,
      main: t.hover,
      dark: t.panel,
      800: t.canvas,
      900: t.bg
    },

    text: {
      primary: t.text,
      secondary: t.text2,
      disabled: t.text3,
      dark: t.text,
      hint: t.text3
    },
    divider: t.border,
    background: {
      paper: t.panel,
      default: t.bg
    },
    action: {
      active: t.text2,
      hover: t.hover,
      selected: t.sel,
      focus: t.hover,
      disabled: t.text3,
      disabledBackground: t.hover
    },

    custom: {
      bg: t.bg,
      canvas: t.canvas,
      panel: t.panel,
      hover: t.hover,
      border: t.border,
      sel: t.sel,
      selRing: t.selRing,
      logoBg: t.logoBg,
      primarySoft: t.primarySoft,
      primaryText: t.primaryText,
      primaryHover: t.primaryHover,
      warn: t.warn,
      warnSoft: t.warnSoft,
      warnBorder: t.warnBorder,
      warnText: t.warnText,
      danger: t.danger,
      dangerSoft: t.dangerSoft,
      dangerBorder: t.dangerBorder,
      successBorder: t.successBorder,
      infoBorder: t.infoBorder,
      status: t.status,
      shadows: t.shadows,
      logoColors: t.logoColors,
      fonts: t.fonts
    }
  };
}